import React from "react";
import { ApolloProvider, Query } from "react-apollo";
import client from "lib/ApolloClient";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import { navigate } from "gatsby";
import ReactLoading from "react-loading";
import { inject, observer } from "mobx-react";
import ResourceGroupLightBox from "components/resource/ResourceGroupLightBox";

const getDBResourceQueryGroup = gql`
  query getDBResourceQueryGroup($searchForm: SearchForm) {
    getDBResourceQueryGroup(Input: $searchForm) {
      queryGroupList {
        title
        index
        list {
          cnt
          title
          value
        }
      }
      propertyList {
        sn
      }
      cooperationList {
        sn
      }
      showStatus
    }
  }
`;

@inject("appStore")
@observer
class DBResourceQueryGroupComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: props.readerStore.auth,
      showSort: false,
      refetch: null,
      closeList: [],
    };
  }

  componentWillReceiveProps(props) {
    if (this.state.auth !== props.readerStore.auth) {
      this.setState({ auth: props.readerStore.auth });
      if (this.state.refetch !== null) {
        this.state.refetch();
      }
    }
  }

  @autobind
  setFilter(ff, fv, e) {
    e.preventDefault();
    if (ff !== "" && fv !== "") {
      let { search, location } = this.props;
      let params = { ...search };
      let { filterField, filterValue } = params;
      filterField = [].concat(filterField || []);
      filterValue = [].concat(filterValue || []);
      filterField.push(ff);
      filterValue.push(fv);
      params.filterField = filterField;
      params.filterValue = filterValue;
      delete params.pageNo;
      navigate([location.pathname, qs.stringify(params)].join("?"));
    }
    if (this.props.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  delAllFilter(e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    delete params.filterField;
    delete params.filterValue;
    delete params.pageNo;
    navigate([location.pathname, qs.stringify(params)].join("?"));
    if (this.props.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  delFilter(field, value, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    let { filterField, filterValue } = params;
    filterField = [].concat(filterField || []);
    filterValue = [].concat(filterValue || []);
    let newFilterField = [];
    let newFilterValue = [];
    filterField.map((v, k) => {
      if (v !== field || filterValue[k] !== value) {
        newFilterField.push(v);
        newFilterValue.push(filterValue[k]);
      }
    });
    if (newFilterField.length > 0) {
      params.filterField = newFilterField;
      params.filterValue = newFilterValue;
    } else {
      delete params.filterField;
      delete params.filterValue;
    }
    navigate([location.pathname, qs.stringify(params)].join("?"));
    if (this.props.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  makeFilterMap(filterField, filterValue) {
    let filterMap = {};
    let filterFieldList = [].concat(filterField || []);
    let filterValueList = [].concat(filterValue || []);
    filterFieldList.map((field, k) => {
      if (field === "class") {
        let values = filterValueList[k].split(":");
        let filterClassMap = filterMap.class || {};
        let filterClassList = [].concat(filterMap.classList || []);
        filterClassList.push(filterValueList[k]);
        let valueList = [].concat(filterClassMap[values[0]] || []);
        valueList.push(values[1]);
        filterClassMap[values[0]] = valueList;
        filterMap.class = filterClassMap;
        filterMap.classList = filterClassList;
      } else {
        let valueList = [].concat(filterMap[field] || []);
        valueList.push(filterValueList[k]);
        filterMap[field] = valueList;
      }
    });
    return filterMap;
  }

  @autobind
  changeSortType(sortType, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.sort = sortType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
    this.setState({ showSort: false });
    if (this.props.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  handleShowSort(e) {
    e.preventDefault();
    this.setState({ showSort: !this.state.showSort });
  }

  @autobind
  openResourceGroupLightBox(type, e) {
    e.preventDefault();
    if (this.queryGroup.refs[type + "GroupLightBox"]) {
      this.queryGroup.refs[type + "GroupLightBox"].popup();
    }
  }

  @autobind
  changeQueryGroupClose(isClose, name, e) {
    e.preventDefault();
    if (isClose) {
      var closeList = [...this.state.closeList];
      var index = closeList.indexOf(name);
      if (index !== -1) {
        closeList.splice(index, 1);
        this.setState({ closeList });
      }
    } else {
      let closeList = [...this.state.closeList];
      closeList.push(name);
      this.setState({ closeList });
    }
  }

  render() {
    let { showSort } = this.state;
    let { t, searchForm, appStore, showList, sortFieldList } = this.props;
    let { filterField, filterValue } = searchForm;
    let filterMap = this.makeFilterMap(filterField, filterValue);
    let filterFieldList = [].concat(filterField || []);
    let { dbResourceCount } = appStore;
    let showQueryGroup = showList && dbResourceCount > 0;
    let form = { ...searchForm };
    delete form["limit"];
    delete form["pageNo"];
    return (
      <>
        <div
          className={
            this.props.showFilter ? "filter_search show_up" : "filter_search"
          }>
          <div
            className="close"
            tabIndex="0"
            onClick={this.props.changeShowFilter.bind(this, false)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.props.changeShowFilter(false, e);
              }
            }}></div>
          <h2>{t("jumperrwd.common.adjustQuery")}</h2>
          <div className="option">
            <div className="name">
              <a
                tabIndex="0"
                onClick={this.handleShowSort.bind(this)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.handleShowSort(e);
                  }
                }}>
                {t("jumperrwd.common.sortType")}
                {sortFieldList.length > 0 &&
                  sortFieldList.map((sortField) => {
                    if (this.props.searchForm.sort === sortField.type) {
                      return ":" + t(sortField.message);
                    }
                    return "";
                  })}
              </a>
            </div>
            {showSort && sortFieldList.length > 0 && (
              <div className="option_list">
                <ul>
                  {sortFieldList.map((sortField) => {
                    return (
                      <li
                        tabIndex="0"
                        onClick={this.changeSortType.bind(this, sortField.type)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.changeSortType(sortField.type, e);
                          }
                        }}>
                        <a>{t(sortField.message)}</a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          <>
            {filterFieldList.length > 0 && (
              <div className="conditions">
                <h3>{t("jumper.common.limiter.tips")}</h3>
                <button
                  type="button"
                  className="del_all"
                  tabIndex="0"
                  onClick={this.delAllFilter.bind(this)}>
                  {t("jumperrwd.common.clearAll")}
                </button>
                <ul>
                  {Object.keys(filterMap).map((key) => {
                    if (key === "source") {
                      return (
                        <li>
                          <h4>{t("jumper.common.limiter.status")}</h4>
                          {filterMap[key].map((value) => {
                            let name = "";
                            if (value === "4") {
                              name = t("jumper.common.limiter.trial");
                            } else if (value === "news") {
                              name = t("jumper.common.limiter.news");
                            } else if (value === "2") {
                              name = t("jumper.common.limiter.order");
                            } else if (value === "1") {
                              name = t("jumper.common.limiter.free");
                            } else if (value === "core") {
                              name = t("jumper.common.limiter.core");
                            } else {
                              name = t("jumperrwd.source.name." + value);
                            }
                            return (
                              <ul>
                                <li>
                                  <button
                                    type="button"
                                    className="del_btn"
                                    tabIndex="0"
                                    onClick={this.delFilter.bind(
                                      this,
                                      "source",
                                      value
                                    )}>
                                    {t("jumperrwd.common.delete")}
                                  </button>
                                  <span>{name}</span>
                                </li>
                              </ul>
                            );
                          })}
                        </li>
                      );
                    } else if (key === "property") {
                      return (
                        <li>
                          <h4>{t("jumper.common.limiter.property")}</h4>
                          {filterMap[key].map((value) => {
                            return (
                              <ul>
                                <li>
                                  <button
                                    type="button"
                                    className="del_btn"
                                    tabIndex="0"
                                    onClick={this.delFilter.bind(
                                      this,
                                      "property",
                                      value
                                    )}>
                                    {t("jumperrwd.common.delete")}
                                  </button>
                                  <span>
                                    {t("jumperrwd.property.name." + value)}
                                  </span>
                                </li>
                              </ul>
                            );
                          })}
                        </li>
                      );
                    } else if (key === "cooperation") {
                      return (
                        <li>
                          <h4>{t("jumper.common.limiter.cooperation")}</h4>
                          {filterMap[key].map((value) => {
                            return (
                              <ul>
                                <li>
                                  <button
                                    type="button"
                                    className="del_btn"
                                    tabIndex="0"
                                    onClick={this.delFilter.bind(
                                      this,
                                      "cooperation",
                                      value
                                    )}>
                                    {t("jumperrwd.common.delete")}
                                  </button>
                                  <span>
                                    {t("jumperrwd.cooperation.name." + value)}
                                  </span>
                                </li>
                              </ul>
                            );
                          })}
                        </li>
                      );
                    } else if (key === "class") {
                      let list = [];
                      Object.keys(filterMap.class).map((key2) => {
                        list.push(
                          <li>
                            <h4>{t("jumperrwd.class.name." + key2)}</h4>
                            {filterMap.class[key2].map((value) => {
                              return (
                                <ul>
                                  <li>
                                    <button
                                      type="button"
                                      className="del_btn"
                                      tabIndex="0"
                                      onClick={this.delFilter.bind(
                                        this,
                                        "class",
                                        key2 + ":" + value
                                      )}>
                                      {t("jumperrwd.common.delete")}
                                    </button>
                                    <span>
                                      {t("jumperrwd.class.name." + value)}
                                    </span>
                                  </li>
                                </ul>
                              );
                            })}
                          </li>
                        );
                      });
                      return list;
                    }
                  })}
                </ul>
              </div>
            )}
            {showQueryGroup && (
              <ApolloProvider client={client.jumperrwdClient}>
                <Query
                  query={getDBResourceQueryGroup}
                  fetchPolicy="network-only"
                  ref={(c) => {
                    this.queryGroup = c;
                  }}
                  variables={{
                    searchForm: form,
                  }}>
                  {({ loading, error, data, refetch }) => {
                    if (loading)
                      return (
                        <center>
                          <ReactLoading
                            type="cylon"
                            height={"10%"}
                            width={"20%"}
                            color="#005D98"
                          />
                        </center>
                      );
                    if (error) return `Error!${error.message}`;
                    if (this.state.refetch === null) {
                      this.setState({ refetch: refetch });
                    }
                    if (data.getDBResourceQueryGroup) {
                      let {
                        queryGroupList,
                        propertyList,
                        cooperationList,
                        showStatus,
                      } = data.getDBResourceQueryGroup;
                      let sourceFilterList = [].concat(filterMap.source || []);
                      let propertyFilterList = [].concat(
                        filterMap.property || []
                      );
                      let cooperationFilterList = [].concat(
                        filterMap.cooperation || []
                      );
                      let classFilterList = [].concat(
                        filterMap.classList || []
                      );
                      let propertyShowFlag = 0;
                      let cooperationShowFlag = 0;
                      return (
                        <div className="sort_list">
                          <ul>
                            {showStatus && (
                              <li>
                                <h3 className="turnicon">
                                  {t("jumper.common.limiter.status")}
                                </h3>
                                <div className="accordion_content">
                                  {!sourceFilterList.includes("4") && (
                                    <ul>
                                      <li>
                                        <a
                                          tabIndex="0"
                                          onClick={this.setFilter.bind(
                                            this,
                                            "source",
                                            "4"
                                          )}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.setFilter("source", "4", e);
                                            }
                                          }}>
                                          {t("jumper.common.limiter.trial")}
                                        </a>
                                      </li>
                                    </ul>
                                  )}
                                  {!sourceFilterList.includes("news") && (
                                    <ul>
                                      <li>
                                        <a
                                          tabIndex="0"
                                          onClick={this.setFilter.bind(
                                            this,
                                            "source",
                                            "news"
                                          )}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.setFilter("source", "news", e);
                                            }
                                          }}>
                                          {t("jumper.common.limiter.news")}
                                        </a>
                                      </li>
                                    </ul>
                                  )}
                                  {!sourceFilterList.includes("2") && (
                                    <ul>
                                      <li>
                                        <a
                                          tabIndex="0"
                                          onClick={this.setFilter.bind(
                                            this,
                                            "source",
                                            "2"
                                          )}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.setFilter("source", "2", e);
                                            }
                                          }}>
                                          {t("jumper.common.limiter.order")}
                                        </a>
                                      </li>
                                    </ul>
                                  )}
                                  {!sourceFilterList.includes("1") && (
                                    <ul>
                                      <li>
                                        <a
                                          tabIndex="0"
                                          onClick={this.setFilter.bind(
                                            this,
                                            "source",
                                            "1"
                                          )}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.setFilter("source", "1", e);
                                            }
                                          }}>
                                          {t("jumper.common.limiter.free")}
                                        </a>
                                      </li>
                                    </ul>
                                  )}
                                  {!sourceFilterList.includes("core") && (
                                    <ul>
                                      <li>
                                        <a
                                          tabIndex="0"
                                          onClick={this.setFilter.bind(
                                            this,
                                            "source",
                                            "core"
                                          )}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.setFilter("source", "core", e);
                                            }
                                          }}>
                                          {t("jumper.common.limiter.core")}
                                        </a>
                                      </li>
                                    </ul>
                                  )}
                                </div>
                              </li>
                            )}
                            {propertyList !== null && (
                              <li>
                                <h3 className="turnicon">
                                  {t("jumper.common.limiter.property")}
                                </h3>
                                <div className="accordion_content">
                                  {(() => {
                                    let propertyDataList = [];
                                    let propertyOut = [];
                                    propertyOut.push(
                                      propertyList.map((property) => {
                                        let propertyData = {
                                          title: t(
                                            "jumperrwd.property.name." +
                                              property.sn
                                          ),
                                          cnt: -1,
                                          value: "" + property.sn,
                                        };
                                        propertyDataList.push(propertyData);
                                        if (
                                          propertyShowFlag < 5 &&
                                          !propertyFilterList.includes(
                                            property.sn.toString()
                                          )
                                        ) {
                                          propertyShowFlag++;
                                          return (
                                            <>
                                              <ul>
                                                <li>
                                                  <a
                                                    tabIndex="0"
                                                    onClick={this.setFilter.bind(
                                                      this,
                                                      "property",
                                                      property.sn
                                                    )}
                                                    onKeyDown={(e) => {
                                                      if (e.key === "Enter") {
                                                        this.setFilter("property", property.sn, e);
                                                      }
                                                    }}>
                                                    {t(
                                                      "jumperrwd.property.name." +
                                                        property.sn
                                                    )}
                                                  </a>
                                                </li>
                                              </ul>
                                            </>
                                          );
                                        }
                                        return "";
                                      })
                                    );
                                    if (propertyShowFlag >= 5) {
                                      propertyOut.push(
                                        <>
                                          <button
                                            type="button"
                                            className="more"
                                            tabIndex="0"
                                            onClick={this.openResourceGroupLightBox.bind(
                                              this,
                                              "property"
                                            )}>
                                            {t("jumperrwd.common.seeMore")}
                                          </button>
                                          <ResourceGroupLightBox
                                            ref="propertyGroupLightBox"
                                            {...this.props}
                                            title={t(
                                              "jumper.common.limiter.cooperation"
                                            )}
                                            index={"cooperation"}
                                            data={propertyDataList}
                                            lightboxClass={"filter_lightbox"}
                                            blockClass={"checkblock"}
                                          />
                                        </>
                                      );
                                    }
                                    return propertyOut;
                                  })()}
                                </div>
                              </li>
                            )}
                            {cooperationList !== null && (
                              <li>
                                <h3 className="turnicon">
                                  {t("jumper.common.limiter.cooperation")}
                                </h3>
                                <div className="accordion_content">
                                  {(() => {
                                    let cooperationDataList = [];
                                    let cooperationOut = [];
                                    cooperationOut.push(
                                      cooperationList.map((cooperation) => {
                                        let cooperationData = {
                                          title: t(
                                            "jumperrwd.cooperation.name." +
                                              cooperation.sn
                                          ),
                                          cnt: -1,
                                          value: "" + cooperation.sn,
                                        };
                                        cooperationDataList.push(
                                          cooperationData
                                        );
                                        if (
                                          cooperationShowFlag < 5 &&
                                          !cooperationFilterList.includes(
                                            cooperation.sn.toString()
                                          )
                                        ) {
                                          cooperationShowFlag++;
                                          return (
                                            <>
                                              <ul>
                                                <li>
                                                  <a
                                                    tabIndex="0"
                                                    onClick={this.setFilter.bind(
                                                      this,
                                                      "cooperation",
                                                      cooperation.sn
                                                    )}
                                                    onKeyDown={(e) => {
                                                      if (e.key === "Enter") {
                                                        this.setFilter("cooperation", cooperation.sn, e);
                                                      }
                                                    }}>
                                                    {t(
                                                      "jumperrwd.cooperation.name." +
                                                        cooperation.sn
                                                    )}
                                                  </a>
                                                </li>
                                              </ul>
                                            </>
                                          );
                                        }
                                        return "";
                                      })
                                    );
                                    if (cooperationShowFlag >= 5) {
                                      cooperationOut.push(
                                        <>
                                          <button
                                            type="button"
                                            className="more"
                                            tabIndex="0"
                                            onClick={this.openResourceGroupLightBox.bind(
                                              this,
                                              "cooperation"
                                            )}>
                                            {t("jumperrwd.common.seeMore")}
                                          </button>
                                          <ResourceGroupLightBox
                                            ref="cooperationGroupLightBox"
                                            {...this.props}
                                            title={t(
                                              "jumper.common.limiter.cooperation"
                                            )}
                                            index={"cooperation"}
                                            data={cooperationDataList}
                                            lightboxClass={"filter_lightbox"}
                                            blockClass={"checkblock"}
                                          />
                                        </>
                                      );
                                    }
                                    return cooperationOut;
                                  })()}
                                </div>
                              </li>
                            )}
                            {queryGroupList !== null &&
                              queryGroupList.map((queryGroup) => {
                                let isClose = this.state.closeList.includes(
                                  "class:" + queryGroup.index
                                );
                                return (
                                  <>
                                    <li>
                                      <h3>
                                        <a
                                          className={isClose ? "" : "turnicon"}
                                          tabIndex="0"
                                          onClick={this.changeQueryGroupClose.bind(
                                            this,
                                            isClose,
                                            "class:" + queryGroup.index
                                          )}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.changeQueryGroupClose(
                                                isClose,
                                                "class:" + queryGroup.index,
                                                e
                                              );
                                            }
                                          }}>
                                          {t(
                                            "jumperrwd.class.name." +
                                              queryGroup.index
                                          )}
                                        </a>
                                      </h3>
                                      {!isClose && (
                                        <div className="accordion_content">
                                          {queryGroup.list !== null &&
                                            queryGroup.list.map((list) => {
                                              if (
                                                !classFilterList.includes(
                                                  queryGroup.index +
                                                    ":" +
                                                    list.value
                                                )
                                              ) {
                                                return (
                                                  <>
                                                    <ul>
                                                      <li>
                                                        <a
                                                          tabIndex="0"
                                                          onClick={this.setFilter.bind(
                                                            this,
                                                            "class",
                                                            queryGroup.index +
                                                              ":" +
                                                              list.value
                                                          )}
                                                          onKeyDown={(e) => {
                                                            if (
                                                              e.key === "Enter"
                                                            ) {
                                                              this.setFilter(
                                                                "class",
                                                                queryGroup.index +
                                                                  ":" +
                                                                  list.value,
                                                                e
                                                              );
                                                            }
                                                          }}>
                                                          {t(
                                                            "jumperrwd.class.name." +
                                                              list.value
                                                          ) +
                                                            "(" +
                                                            list.cnt +
                                                            ")"}
                                                        </a>
                                                      </li>
                                                    </ul>
                                                  </>
                                                );
                                              }
                                              return "";
                                            })}
                                        </div>
                                      )}
                                    </li>
                                  </>
                                );
                              })}
                          </ul>
                        </div>
                      );
                    }
                    return "";
                  }}
                </Query>
              </ApolloProvider>
            )}
          </>
        </div>
      </>
    );
  }
}

export default DBResourceQueryGroupComp;
